

import { CheckCircleOutline } from "@mui/icons-material"
import {Stack, SvgIconProps, Typography, TypographyProps} from "@mui/material"
import React from "react"
import { BlockRendererContent, TextBlockRenderer } from "../../../strapi/blockRenderer"

export type TextItemProps = {
    id: string
    Heading: string
    Icon?: 'Tick' | null
    Content?: BlockRendererContent
    SlotProps?: {
        Heading?: TypographyProps
        Content?: TypographyProps
        SvgIcon?: SvgIconProps
    }
}

export const TextItemComponent = ({ Heading, Icon, SlotProps, Content }: TextItemProps) => {
    // const theme = useTheme();

    return (
        <Stack gap={1} direction={'row'} justifyContent='flex-start' alignItems='center' sx={{ width: '100%' }}>
            {Icon && <CheckCircleOutline color="primary" {...SlotProps?.SvgIcon} />}
            <Typography gutterBottom={false} variant="body2" fontSize={'0.9rem!important'} {...SlotProps?.Heading}>{Heading}</Typography>
            {Content && <Typography variant="body2" component={"div"} fontSize={'0.7rem!important'} {...SlotProps?.Content}><TextBlockRenderer content={Content} /></Typography>}
        </Stack>
    )
}